import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

type BackButtonProps = {
  onClick?: () => void;
  to?: string;
};

export const BackButton = ({ onClick, to }: BackButtonProps) => {
  const navigate = useNavigate();

  return (
    <Button
      type="button"
      variant="text"
      color="primary"
      startIcon={<ArrowBackRoundedIcon />}
      onClick={onClick || (() => to && navigate({ pathname: to }))}
      sx={{
        alignSelf: "flex-start",
        minWidth: "auto",
        px: 1,
        ml: -1,
        fontSize: 14,
        fontWeight: 600,
        "&:hover": { bgcolor: "primary.light" },
      }}
    >
      Volver
    </Button>
  );
};
